import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import FJDropboxLoadingModal from "../view/FJDropboxLoadingModal";
import {FJExportVideoAction, FJModalAction} from "../../../redux/action/FJRoot.action";

class FJDropboxLoadingModalContainer extends Component {

  render() {
    let {
      visible,
      hide,
    } = this.props;
    return (
      <FJCommonModal visible={visible} >
        <FJDropboxLoadingModal onHide={hide} />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowDropboxModal
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    hide: function () {
      dispatch(FJModalAction.setIsShowDropboxModalAction(false));
      dispatch(FJExportVideoAction.cancelShareDropboxAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJDropboxLoadingModalContainer);
